import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { IncrementalSalesBox } from '../../organisms/IncrementalSalesBox';
import { MediaInvestmentBox } from '../../organisms/MediaInvestmentBox';
import { ROIBox } from '../../organisms/ROIBox';
import { ROMIBox } from '../../organisms/ROMIBox';
import { SalesAndPredictedSalesBox } from '../../organisms/SalesAndPredictedSalesBox';

export const Overview: React.FC = () => {
  const { romiEnabled } = useMMDataContext();
  return (
    <>
      <MediaInvestmentBox />
      <IncrementalSalesBox />
      {romiEnabled ? <ROMIBox /> : <ROIBox />}
      <SalesAndPredictedSalesBox />
    </>
  );
};
